import { lowerFirst } from 'lodash';

import { customCellWidth, localStorageKeys } from '@/shared/utils/constants';
import { AccessKeySortingColumns } from '~/common/enums';

import AccessKeyAvailableBuildingsTableCell from '../components/AccessKeyAvailableBuildingsTableCell';
import AccessKeyAvailableBuildingUnitsTableCell from '../components/AccessKeyAvailableBuildingUnitsTableCell';
import AccessKeyCoOwnerNameCell from '../../overview/components/AccessKeyCoOwnerNameCell';
import SelectAccessKeyActionsCell from '../components/SelectAccessKeyActionsCell';
import TruncatedCell from '@/shared/components/2.0/customTableCells/TruncatedCell';

export const sortableColumns = [
  lowerFirst(AccessKeySortingColumns.Description),
  lowerFirst(AccessKeySortingColumns.Remark),
];

const useAccessKeyActionAvailableAccessKeysTableConfig = () => ({
  columns: [
    {
      customCellComponent: TruncatedCell,
      key: 'code',
      title: '_accessKeys.columns.code',
      width: customCellWidth.S,
    },
    {
      customCellComponent: TruncatedCell,
      key: 'accessKeyInstanceRemark',
      title: '_accessKeys.columns.remark',
      width: customCellWidth.S,
    },
    {
      customCellComponent: TruncatedCell,
      key: 'accessKeyDescription',
      title: '_accessKeys.columns.description',
      width: customCellWidth.S,
    },
    {
      customCellComponent: AccessKeyAvailableBuildingsTableCell,
      key: 'buildings',
      title: '_accessKeys.columns.building',
      width: customCellWidth.S,
    },
    {
      customCellComponent: AccessKeyAvailableBuildingUnitsTableCell,
      key: 'buildingUnits',
      title: '_accessKeys.columns.unit',
      width: customCellWidth.S,
    },
    {
      customCellComponent: AccessKeyCoOwnerNameCell,
      key: 'coOwnerName',
      title: '_accessKeys.columns.coOwner',
      width: customCellWidth.S,
    },
    {
      allowDeselect: false,
      customCellComponent: SelectAccessKeyActionsCell,
      key: 'accessKeyInstanceId',
      title: ' ',
      width: customCellWidth.S,
    },
  ],
  localStorageKey: localStorageKeys.accessKeys.availableAccessKeys.COLUMNS,
  rowId: 'id',
  rowKeyField: 'id',
});

export default useAccessKeyActionAvailableAccessKeysTableConfig;
